import React, { Fragment, useState } from 'react';
import './index.scss';
import { useSelector, useDispatch } from 'react-redux';
import { Skeleton } from '@mui/material';
import json from '../tempDetails.json';
import CustomFlip from '../common/filp';
import DisclosureContent from './DisclosureContent';
import { profile360Selector, profile360_actions } from '../js/slice';
import { getRouteAccess } from '../../../utils/access-utils';

function PurposefulEngagement() {
  const dispatch = useDispatch();
  const purposefulEngagement = useSelector(
    profile360Selector.purposefulEngagement,
  );

  const handleHisory = () => {
    dispatch(
      profile360_actions.openModal({
        title: 'History',
        isFor: 'purposeful-engagement',
        data: { type: 'history' },
      }),
    );
  };

  const Disclouser = ({ label = '', options = [], parentKey = '' }) => {
    const [viewMore, setViewMore] = useState(false);

    // Do not mutate props
    const pendingOptions = options.filter((o) => !o.isDone);
    if (pendingOptions.length === 0) return null;

    // Compute height without nested ternary
    let height = '0px';
    if (viewMore) {
      height = `${61 * pendingOptions.length}px`;
    } else if (pendingOptions.length >= 2) {
      height = `${61 * 2}px`;
    } else if (pendingOptions.length === 1) {
      height = '61px';
    }

    return (
      <div className="Engagements">
        <div className="flex justify-between items-center mb-17px">
          <div className="heading">{label}</div>

          {pendingOptions.length > 2 && (
            <div
              className="cursor-pointer"
              style={{ width: '58.31px', height: '14.9px' }}
            >
              <CustomFlip
                isFlip={viewMore}
                height="100%"
                width="100%"
                front={
                  <span
                    className="view-more text-300 cursor-pointer"
                    onClick={() => setViewMore((v) => !v)}
                  >
                    View More
                  </span>
                }
                back={
                  <span
                    className="view-more text-300 cursor-pointer"
                    onClick={() => setViewMore((v) => !v)}
                  >
                    View Less
                  </span>
                }
              />
            </div>
          )}
        </div>

        <div
          style={{
            overflow: 'hidden',
            height,
            transition: '0.6s height',
          }}
        >
          {pendingOptions.map((data, idx) => (
            <Fragment key={idx}>
              <DisclosureContent data={{ parentKey, ...data }} />
            </Fragment>
          ))}
        </div>
      </div>
    );
  };

  const Title = () => {
    const { write: isEditPermission } = getRouteAccess('profile-360');
    return (
      <div className="flex justify-between items-center title-base-div">
        <div className="title">Purposeful Engagement</div>
        <div
          onClick={isEditPermission ? handleHisory : undefined}
          className={`history text-300 ${!isEditPermission ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
        >
          HISTORY
        </div>
      </div>
    );
  };

  const PurposeFullSkelton = () => (
    <div>
      {[133, 143].map((h, index) => (
        <div key={index} className="pt-24px">
          <div className="mb-17px flex justify-between items-center">
            <Skeleton variant="rounded" width={h} height={19} />
            <Skeleton variant="rounded" width={58} height={14} />
          </div>
          <div>
            <Skeleton
              className="mb-16px"
              variant="rounded"
              width={'100%'}
              height={45}
            />
            <Skeleton
              className="mb-16px"
              variant="rounded"
              width={'100%'}
              height={45}
            />
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <section className="PurposefulEngagement">
      <Title />
      {purposefulEngagement.loader ? (
        <PurposeFullSkelton />
      ) : (
        json.PurposefulEngagement.map((data, idx) => (
          <Fragment key={idx}>
            {Array.isArray(purposefulEngagement?.data[data.key])
              && purposefulEngagement.data[data.key].length > 0 && (
              <Disclouser
                parentKey={data.key}
                label={data.label}
                options={purposefulEngagement.data[data.key]}
              />
            )}
          </Fragment>
        ))
      )}
    </section>
  );
}

export default PurposefulEngagement;
